import { Area } from "./area.model";
import { Feeder33 } from "./f33.model";
import { Feeder, FeederType } from "./feeder.model";
import { Feeder11 } from "./feeder11.model";
import { HistoryOutput } from "./history.model";


export interface DtCustomerCreate {
  externalId: number;
  name: string;
  number: string;
  connectedFeederNumber: string;
  feeder11?: Feeder11;
  feeder33?: Feeder33;
}
export function getInitDtCustomer(): DtCustomerCreate {
  return {
    externalId: 0,
    name: '',
    number: '',
    connectedFeederNumber: '',
    feeder11: {
      id: 0,
      name: '',
      number: '',
      substation: '',
    },
  };
}

export interface DtCrud {
  id: number;
  name: string;
  number: string;
  area: Area;
  feeder: Feeder;
  feederType: FeederType;
  history: HistoryOutput;
  utilityId: number;
  code: string;
  meterNumber?: string;
  meterBrandId?: number;
}

export interface DtCrudCreate {
  id: number;
  name: string;
  number: string;
  areaId: number;
  feederId: number;
  feederType: FeederType;
  history?: HistoryOutput;
  utilityId?: number;
  meterNumber?: string;
  meterBrandId?: number;
}


export function initDtCrud(): DtCrud {
  return {
    id: 0,
    name: '',
    number: '',
    area: new Area(),
    feeder: new Feeder(),
    feederType: FeederType.NOT_SELECTED,
    history: new HistoryOutput(),
    utilityId: 0,
    code: '',
    meterNumber: '',
    meterBrandId: undefined,
  };
}


export function mapObjToCreateObj(dt: DtCrud): DtCrudCreate {
  return {
    id: dt.id,
    name: dt.name,
    number: dt.number,
    areaId: dt.area.id,
    feederId: dt.feeder.id,
    feederType: dt.feeder.feederType,
    history: dt.history,
    utilityId: dt.utilityId,
    meterNumber: dt.meterNumber,
    meterBrandId: dt.meterBrandId,
  };
}


export function getInitDtDto(): DtDto {
  return {
    id: 0,
    name: '',
    number: '',
    area: new Area(),
    feeder: {
      id: 0,
      name: '',
      number: '',
      feederType: FeederType.NOT_SELECTED,
    },
    latitude: 0,
    longitude: 0,
  };
}

export class DtDto {
  id: number;
  name: string;
  number: string;
  area: Area;
  feeder: Feeder;
  latitude: number;
  longitude: number;

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.name = data?.name ?? '';
    this.number = data?.number ?? '';
    this.area = new Area(data?.area);
    this.feeder = new Feeder(data?.feeder);
    this.latitude = data?.latitude ?? 0;
    this.longitude = data?.longitude ?? 0;
  }
}

export enum DTType {
  Private = 1,
  Public = 2,
  MDAs = 3,
  Utility = 4
}

export enum DTStatus {
  Active = 1,
  Inactive = 2,
  Suspended = 3,
  Decommissioned = 4,
}

export class DtForSelect {
  externalId: number;
  slrnId: string;
  name: string;
  number: string;
  area: Area;
  areaId: number;
  guid: string;
  feeder11Id?: number;
  feeder33Id?: number;
  latitude?: number;
  longitude?: number;
  connectedFeederNumber: string;
}